import React, { startTransition, useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import Moment from 'moment-timezone'
import { withAuth } from '@praxis/component-auth'
import { makeStyles } from '@material-ui/core/styles'
import NoThumbnail from '../../images/NoThumbnail.svg?url'
import ImageNA from '../../images/ImageNA.svg'
import AddToDriveIcon from '@mui/icons-material/AddToDrive'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import ReplayIcon from '@mui/icons-material/Replay'
import DeleteIcon from '@mui/icons-material/Delete'
import WarningIcon from '@mui/icons-material/Warning'
import ErrorIcon from '@mui/icons-material/Error'
import CloseIcon from '@mui/icons-material/Close'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useDispatch } from 'react-redux'
import {
  Alert,
  AlertTitle,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import {
  appendAHKeyParamToUrl,
  appendQueryParams,
} from '../../helpers/UrlHelper'
import { openZoomedImage } from '../../store/TcinInfo/actionCreator'
import { callRepurposeAHImages } from '../../store/Dashboard/actionCreator'
import { green } from '@material-ui/core/colors'
import { TableBody } from '@material-ui/core'
import CreatableSelect from '../../components/ReactSelect/CreatableSelect'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { extractFileType, removeFileExtension, sortAlphaNum } from './utils'
import {
  assignSourceImagesTableCols,
  stepperCaptions,
  stepperLabels,
} from './constants'
import { convertUTCtoLocal } from '../../helpers/dateHelper'
import { FileDownloadOff, GetApp } from '@mui/icons-material'
import { parseISO } from 'date-fns'

const PackagingAssetsList = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const {
    data,
    lanId = '',
    repurposeLoading = false,
    packagingAssetUploadedDate = '',
  } = props
  const { repurpose_info = {}, image_information = {} } = data || {}

  const { main: mainImageInfo = {}, alt: altImagesInfo = [] } =
    image_information || {}
  const sourceImagesList = [{ ...mainImageInfo }, ...(altImagesInfo || [])]

  const defaultSourceImagesDDList = sourceImagesList
    ?.filter((sobj) => sobj)
    ?.map((mobj = {}) => {
      const { file_name = '' } = mobj
      const fileNameValue = removeFileExtension(file_name)
      return {
        label: fileNameValue,
        value: file_name,
      }
    })

  const [drmOpen, setDrmOpen] = useState(false)
  const [currentDrm, setCurrentDrm] = useState(Number(0))
  const { asset_info = [] } = repurpose_info || {}
  const [repurposeList, setRepurposeList] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [finalSelectedData, setFinalSelectedData] = useState([])
  const [selDataDuplicates, setSelDataDuplicates] = useState([])
  const [failedFiles, setFailedFiles] = useState([])
  const [successFiles, setSuccessFiles] = useState([])
  const [activeStep, setActiveStep] = useState(0)
  const [sourceImagesDDList, setSourceImagesDDList] = useState(
    defaultSourceImagesDDList || []
  )
  const [repurposeStatus, setRepurposeStatus] = useState('')
  const [payload, setPayload] = useState([])
  const [showRepurposeLoader, setShowRepurposeLoader] = useState(false)
  const [assetFilterText, setAssetFilterText] = useState('')

  const renderNoRecords = () => {
    return (
      <Typography variant="h5" gutterBottom>
        {'No Results Found'}
      </Typography>
    )
  }

  const renderFileName = (fileName = '', imgSrc = '') => {
    return (
      <Tooltip
        title={fileName}
        placement="top-start"
        disableHoverListener={fileName?.length <= 15 ? true : false}
      >
        <a
          data-cy="assetCardLink"
          alt={fileName}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (imgSrc) {
              dispatch(openZoomedImage(fileName, imgSrc))
            }
          }}
          className={classes.fileName}
          href={() => false}
        >
          {fileName}
        </a>
      </Tooltip>
    )
  }

  const renderChannel = (channel) => {
    return (
      <Tooltip
        title={channel}
        placement="top-start"
        disableHoverListener={channel?.length <= 15 ? true : false}
      >
        <span>{channel}</span>
      </Tooltip>
    )
  }

  const onSelection = (event, asset) => {
    const { asset_id = '' } = asset
    const isSelected = selectedData?.some((obj) => obj?.asset_id === asset_id)
    const newSelected = isSelected
      ? selectedData?.filter((obj) => obj?.asset_id !== asset_id)
      : [...selectedData, asset]

    setSelectedData(newSelected)
  }

  const onCheckBoxHeaderChange = () => {
    const selectedIds = (asset_info || []).filter(
      (aobj) => extractFileType(aobj.file_name) !== 'ai'
    )
    const allSelected = selectedIds?.every((asset) => {
      return selectedData?.some(
        (selected) => selected?.asset_id === asset?.asset_id
      )
    })
    const newSelected = allSelected ? [] : [...selectedIds]
    setSelectedData(newSelected)
  }

  const renderCardHeader = (asset = {}) => {
    const {
      render_urls: { preview_asset_url = '' } = {},
      file_name: fileName = '',
      asset_id = '',
      upload_date,
      source_channel = '',
    } = asset
    const assetFileType = extractFileType(fileName) || ''
    const srcUrl = preview_asset_url
      ? appendAHKeyParamToUrl(preview_asset_url)
      : ''
    const isCardChecked =
      (selectedData || [])?.findIndex((obj) => obj?.asset_id === asset_id) !==
      -1
    return (
      <Grid container alignItems={'baseline'} spacing={0.7}>
        <Grid item container>
          <Grid item>
            <Checkbox
              checked={isCardChecked}
              disabled={assetFileType === 'ai'}
              onChange={(event) => {
                onSelection(event, asset)
              }}
              id={asset_id}
              inputProps={{ 'aria-label': 'controlled' }}
              classes={{
                root: classes.checkBoxCls,
              }}
            />
          </Grid>
          <Grid item>{renderFileName(fileName, srcUrl)}</Grid>
        </Grid>
        <Grid item container className={classes.uploadDate}>
          <Grid item>
            <b>Channel</b>: {renderChannel(source_channel)}
          </Grid>
          <Grid item>{convertUTCtoLocal(upload_date)}</Grid>
        </Grid>
      </Grid>
    )
  }

  const getRepurposeStatus = (failedFiles = [], successList = []) => {
    if (failedFiles?.length > 0) {
      return successList?.length > 0 ? 'partial' : 'failed'
    } else if (successList?.length > 0) {
      return 'success'
    }
    return ''
  }

  const callRepurposeAPICB = (resData = {}) => {
    let { failed_files = [] } = resData || {}
    const successList = (finalSelectedData || [])?.filter(
      (asset) =>
        (failed_files || [])?.findIndex(
          (obj) => obj?.asset_id === asset?.asset_id
        ) === -1
    )
    const failedList = (finalSelectedData || [])?.filter(
      (asset) =>
        (failed_files || [])?.findIndex(
          (obj) => obj?.asset_id === asset?.asset_id
        ) !== -1
    )

    const repurposeStatusVal = getRepurposeStatus(failedList, successList)
    startTransition(() => {
      if (failedList?.length > 0) {
        setFailedFiles(failedList || [])
      }
      if (successList?.length > 0) {
        setSuccessFiles(successList || [])
      }
      setRepurposeStatus(repurposeStatusVal)
      setFinalSelectedData(failedList || []) //Note - To show the failed list in the final repurpose step
      reviewButtonOnClick('forward')
    })
  }

  React.useEffect(() => {
    setShowRepurposeLoader(repurposeLoading)
    return function cleanup() {}
  }, [repurposeLoading])

  React.useEffect(() => {
    if (payload?.length > 0) {
      callRepurposeAPI(payload, callRepurposeAPICB)
    }
    return function cleanup() {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload])

  useEffect(() => {
    if (selectedData?.length > 0) {
      const finalSelectedData = selectedData?.filter(
        (fobj) => fobj?.source_image_data?.source_file_name
      )
      const finalRepurposeList = repurposeList?.filter(
        (fobj) => fobj?.source_file_name
      )

      const duplicates = findDuplicateFilesWithAssetIds(finalSelectedData)

      setFinalSelectedData(finalSelectedData)
      setRepurposeList(finalRepurposeList)
      setSelDataDuplicates(duplicates)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData, selectedData.length])

  const callRepurposeAPI = (assetList = [], callBack = () => {}) => {
    dispatch(callRepurposeAHImages({ assetList, callBack, lanId }))
  }

  const sortUsageInfoByExpDate = (usage_info) => {
    const usageInfo = [...usage_info]
    usageInfo.sort(
      (item1, item2) =>
        new Date(item1.expiration_date) - new Date(item2.expiration_date)
    )
    return usageInfo
  }

  const checkUsageRightsExpiry = (usageRightsList = []) => {
    let usageExpiryStatus = false
    if (!usageRightsList?.length) {
      return usageExpiryStatus
    }
    const filteredUsageInfo = usageRightsList.filter(
      (urm) =>
        !urm.expiration_date?.includes('9999') ||
        !urm.expirationDate?.includes('9999')
    )
    if (filteredUsageInfo.length) {
      filteredUsageInfo.forEach((urmDetails) => {
        const usageExpiryDate =
          urmDetails.expiration_date || urmDetails.expirationDate
        if (
          usageExpiryDate &&
          new Date(usageExpiryDate).getTime() < new Date().getTime()
        ) {
          usageExpiryStatus = true
        }
      })
    }
    return usageExpiryStatus
  }

  const onDrmClick = () => {
    setDrmOpen(!drmOpen)
  }

  const formatUsageRightsDate = (dateTime = new Date()) =>
    Moment(dateTime).utc('Z').format('LL')

  const checkIfUlimited = (usage_info) => {
    if (
      Object.keys(usage_info).length === 0 ||
      Object.keys(usage_info[0]).length === 0
    ) {
      return true
    }
    const usageLength = usage_info.length
    let count = 0
    for (let i = 0; i < usage_info.length; i++) {
      const { expiration_date = null } = usage_info[i] || {}
      let formattedExpDate = ''
      if (expiration_date && expiration_date !== 'null') {
        formattedExpDate = Moment(new Date(expiration_date).toISOString())
          .utc()
          .local()
          .format('YYYY-MM-DD')
      }
      if (
        usage_info[i].available_channels === 'Any and All Media' &&
        formattedExpDate === '9999-12-31'
      ) {
        count++
      }
    }
    if (count === usageLength) {
      return true
    } else {
      return false
    }
  }

  const nextDrm = (current, length) => {
    if (current !== length - 1) {
      setCurrentDrm(currentDrm + 1)
    } else {
      setCurrentDrm(Number(0))
    }
  }

  const prevDrm = (current, length) => {
    if (current !== 0) {
      setCurrentDrm(currentDrm - 1)
    } else {
      setCurrentDrm(length - 1)
    }
  }

  const renderDownloadDiv = (fileDownloadUrl = '') => {
    const originalUrl = fileDownloadUrl
      ? appendAHKeyParamToUrl(fileDownloadUrl)
      : ''
    const downloadUrl = originalUrl
      ? appendQueryParams(originalUrl, { is_download: true })
      : ''

    return (
      <Button
        aria-haspopup="true"
        className={classes.dropdownButton}
        disabled={isEmpty(downloadUrl)}
      >
        {!isEmpty(downloadUrl) ? (
          <a href={downloadUrl} download className={classes.dropdownButton}>
            <GetApp />
          </a>
        ) : (
          <FileDownloadOff width="20" height="20" />
        )}
      </Button>
    )
  }

  const drmCloseContent = (asset = {}) => {
    const { render_urls: { original_asset_url = '' } = {} } = asset

    return (
      <Grid
        container
        direction="row"
        justifyContent={'flex-end'}
        alignItems={'center'}
      >
        <Grid item>{renderDownloadDiv(original_asset_url)}</Grid>
      </Grid>
    )
  }

  const drmOpenContent = (asset = {}) => {
    const { creative_usage_instructions = {}, usage_info = [] } = asset

    const sortedUsageInfo =
      usage_info?.length && Object.keys(usage_info[0] || {}).length
        ? sortUsageInfoByExpDate(usage_info)
        : {}

    const usageRightsInfo = Object.assign({}, sortedUsageInfo[currentDrm])
    const {
      rights_holder_name = '',
      drm_id = '',
      available_channels = '',
      available_territories = '',
      buyer = '',
      custom_usage_rights = false,
      rights_holder_type = '',
      expiration_date = '',
      custom_usage_rights_language = '',
      usage_rights_language = '',
    } = usageRightsInfo

    return (
      <div>
        <Grid container direction={'row'} spacing={1}>
          <Grid item xs={12} lg={12} md={12}>
            <Grid
              container
              direction="row"
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Grid item>
                {creative_usage_instructions?.do_not_use === true ? (
                  <div className={classes.usageHeader}>
                    <ErrorIcon
                      className={classes.useCardIcon}
                      style={{ color: 'rgba(204, 0, 0, 1)' }}
                    />
                    Do Not Use
                  </div>
                ) : checkUsageRightsExpiry(sortedUsageInfo) ? (
                  <div className={classes.usageHeader}>
                    <WarningIcon
                      className={classes.useCardIcon}
                      style={{ color: 'rgba(223, 139, 72, 1)' }}
                    />
                    Expired
                  </div>
                ) : (
                  <div className={classes.usageHeader}>
                    <WarningIcon
                      className={classes.useCardIcon}
                      style={{ color: 'rgba(223, 139, 72, 1)' }}
                    />
                    Limited Use
                  </div>
                )}
              </Grid>
              <Grid item>
                <IconButton onClick={onDrmClick} size="large">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {creative_usage_instructions?.do_not_use === true ? (
          <div className={classes.usageContainerCreative}>
            <div className={classes.usageInfo}>
              <div className={classes.usageText}>
                <b>Creative Usage Instructions: </b>
                {creative_usage_instructions?.instructions
                  ? creative_usage_instructions?.instructions
                  : 'Information not provided'}
              </div>
              <div className={classes.usageText}>
                <b>Additional Directions: </b>
                {creative_usage_instructions?.additional_directions
                  ? creative_usage_instructions?.additional_directions
                  : 'Information not provided'}
              </div>
            </div>
          </div>
        ) : (
          <div className={classes.usageContainer}>
            <div className={classes.usageInfo}>
              <div className={classes.drmId}>
                DRM{drm_id ? drm_id.replace('DRM', '') : ''}
              </div>
              <div className={classes.usageText}>
                <b>Buyer: </b> {buyer}
              </div>
              <div className={classes.usageText}>
                <b>Rights holder name: </b> {rights_holder_name}
              </div>
              <div className={classes.usageText}>
                <b>Rights holder type: </b> {rights_holder_type}
              </div>
              <div className={classes.usageText}>
                <b>Available channels: </b> {available_channels}
              </div>
              <div className={classes.usageText}>
                <b>Available territories: </b> {available_territories}
              </div>
              <div className={classes.usageText}>
                <b>Expiration date: </b>{' '}
                {formatUsageRightsDate(expiration_date)}
              </div>
              <div className={classes.usageText}>
                <b>Usage Rights Language: </b>
              </div>
              <div className={classes.urmLangText}>
                {custom_usage_rights
                  ? custom_usage_rights_language
                  : usage_rights_language}
              </div>
            </div>
            {sortedUsageInfo?.length > 1 ? (
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems={'center'}
                className={classes.drmNav}
              >
                <IconButton
                  onClick={() => prevDrm(currentDrm, sortedUsageInfo?.length)}
                  className={classes.navButton}
                  size="large"
                >
                  <ArrowForwardIosIcon
                    style={{ transform: 'scaleX(-1)' }}
                    className={classes.navButton}
                  />
                </IconButton>
                <div className={classes.navText}>
                  {currentDrm + 1} of {sortedUsageInfo.length}
                </div>
                <IconButton
                  onClick={() => nextDrm(currentDrm, sortedUsageInfo.length)}
                  className={classes.navButton}
                  size="large"
                >
                  <ArrowForwardIosIcon className={classes.navButton} />
                </IconButton>
              </Grid>
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
    )
  }

  const renderCardContent = (asset = {}) => {
    const {
      render_urls: { preview_asset_url = '' } = {},
      file_name: fileName = '',
      creative_usage_instructions = {},
      usage_info = [],
    } = asset
    const sortedUsageInfo =
      usage_info?.length && Object.keys(usage_info[0] || {}).length
        ? sortUsageInfoByExpDate(usage_info)
        : {}

    const srcUrl = preview_asset_url
      ? appendAHKeyParamToUrl(preview_asset_url)
      : ''

    const borderStyle =
      parseISO(asset.upload_date) > packagingAssetUploadedDate
        ? { border: '2px solid #cc0000', width: `calc(100% - 4px)` }
        : {}
    return (
      <Grid container direction={'row'}>
        {!drmOpen ? (
          <>
            <Grid item xs={12} lg={12} md={12}>
              <a
                data-cy="assetCardLink"
                alt={fileName}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  if (srcUrl) {
                    dispatch(openZoomedImage(fileName, srcUrl))
                  }
                }}
                className={classes.imgBlockCls}
                href={() => false}
              >
                <img
                  src={srcUrl ? srcUrl : NoThumbnail}
                  alt="Not Found"
                  onError={(e) => {
                    e.target.src = NoThumbnail
                  }}
                  className={classes.imgBlockCls}
                  style={borderStyle}
                />
              </a>
            </Grid>
            <Grid item xs={12} lg={12} md={12}>
              {drmCloseContent(asset)}
            </Grid>
          </>
        ) : (sortedUsageInfo.length > 0 &&
            Object.keys(sortedUsageInfo[0]).length > 0) ||
          creative_usage_instructions?.do_not_use === true ? (
          <>{drmOpenContent(asset)}</>
        ) : (
          <div className={classes.usageInfo}>
            <Grid container direction={'row'} spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Grid item>
                    <div className={classes.drmId}>No Details Available</div>
                  </Grid>
                  <Grid item>
                    <IconButton onClick={onDrmClick} size="large">
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}
      </Grid>
    )
  }

  /**
   * Renders an asset card with appropriate styling and content based on its status.
   *
   * @param {Object} asset - The asset object containing details about the file.
   * @param {string} [asset.file_name=''] - The name of the file associated with the asset.
   * @param {string} [asset.asset_id=''] - The unique identifier for the asset.
   *
   * @returns {JSX.Element} - A Material-UI Card component styled and populated with the asset's details.
   *
   * @description
   * - Calls `renderCardHeader` and `renderCardContent` to populate the card's content.
   */
  const renderAssetCard = (asset = {}) => {
    const { file_name = '', asset_id = '' } = asset
    const errorFiles = failedFiles || []
    const cardClass =
      errorFiles?.findIndex((obj) => obj?.asset_id === asset_id) !== -1
        ? classes.errorCard
        : (successFiles || [])?.findIndex(
              (obj) => obj?.asset_id === asset_id
            ) !== -1
          ? classes.successCard
          : classes.card
    const cardType =
      errorFiles?.findIndex((obj) => obj?.asset_id === asset_id) !== -1
        ? 'error'
        : (successFiles || [])?.findIndex(
              (obj) => obj?.asset_id === asset_id
            ) !== -1
          ? 'success'
          : 'normal'
    const altImageData = (altImagesInfo || []).find(
      (img) => img.file_name === file_name || img.asset_id === asset_id
    )
    const mainImageData =
      (mainImageInfo || {})?.asset_id === asset_id ||
      (mainImageInfo || {})?.file_name === file_name
        ? mainImageInfo
        : {}
    const imageData =
      mainImageData && Object.entries(mainImageData || {})?.length > 0
        ? mainImageData
        : altImageData && Object.entries(altImageData || {})?.length > 0
          ? altImageData
          : {}
    return (
      <Card sx={{ maxWidth: 345 }} className={cardClass}>
        <CardActions style={{ borderBottom: '1px solid #f4f0f0' }}>
          {renderCardHeader(asset)}
        </CardActions>
        <>{renderCardContent(asset)}</>
      </Card>
    )
  }

  /**
   * Renders a list of asset cards inside a Grid layout.
   *
   * @param {Array<Object>} [assetsList=[]] - The list of asset objects to be rendered.
   *
   * @returns {JSX.Element | string} - A list of Grid items containing asset cards if the list is not empty, otherwise an empty string.
   *
   * @description
   * - Iterates over the `assetsList` array and renders each asset using the `renderAssetCard` function.
   * - Wraps each asset card in a Material-UI `Grid` item with custom styling.
   * - Returns an empty string if the `assetsList` is empty.
   */
  const renderAssetList = (assetsList = []) => {
    return assetsList?.length > 0
      ? (assetsList || [])?.map((asset) => {
          return <Grid item>{renderAssetCard(asset)}</Grid>
        })
      : ''
  }

  const findDuplicateFilesWithAssetIds = (selectedData) => {
    const fileMap = new Map()
    const duplicates = []

    for (const obj of selectedData) {
      const fileName = obj?.source_image_data?.source_file_name
      const assetId = obj?.asset_id

      if (fileName) {
        if (fileMap?.has(fileName)) {
          duplicates?.push({ file_name: fileName, asset_id: assetId })
        } else {
          fileMap?.set(fileName, assetId)
        }
      }
    }

    return duplicates
  }

  const finalPayload = () => {
    const extractedData = finalSelectedData.map(
      ({
        file_name = '',
        asset_id = '',
        source_image_data = {},
        source_channel,
      }) => ({
        repurpose_file_name: file_name || '',
        asset_id: asset_id || '',
        source_file_name: source_image_data?.source_file_name || '',
        channel: source_channel || '',
      })
    )
    return extractedData
  }

  const reviewButtonOnClick = (stepType = 'forward') => {
    let activeStepCopy = Number(activeStep)
    if (
      stepType === 'forward' &&
      activeStepCopy <= stepperLabels.length &&
      activeStepCopy >= Number(0)
    ) {
      activeStepCopy = Number(activeStepCopy) + Number(1)
      setActiveStep(activeStepCopy)
    }
    if (stepType === 'backward') {
      activeStepCopy = Number(activeStepCopy) - Number(1)
      setActiveStep(activeStepCopy)
    }
  }

  const completeRepurposeOnclick = () => {
    startTransition(() => {
      setShowRepurposeLoader(true)
      setPayload(finalPayload() || [])
    })
  }

  /**
   * Renders the appropriate page controls (buttons) based on the current active step in the workflow.
   *
   * @returns {JSX.Element | null} - A Material-UI `Button` component for the current step, or `null` if no step matches.
   *
   * @description
   * - The function determines the button to render based on the `activeStep` value.
   * - Each step has its own button with specific behavior:
   *   - **Step 0**: Displays a "REPURPOSE" button that formats the `selectedData` and sets the `repurposeList`.
   *   - **Step 1**: Displays a "Review Details" button that validates the `selectedData` and checks for duplicate source file names.
   *   - **Step 2**: Displays a "Complete Repurpose" button that triggers the final step in the workflow.
   * - The buttons are conditionally disabled based on the state of `selectedData` or other validations.
   */
  const renderPageControls = () => {
    switch (activeStep) {
      case Number(0): {
        return (
          <Button
            data-id={'repurposeSelected'}
            onClick={() => {
              const formattedList = selectedData?.map((sobj) => {
                const { file_name = '', asset_id = '' } = sobj || {}
                return {
                  existing_file_name: file_name,
                  asset_id: asset_id,
                }
              })
              setRepurposeList(formattedList)
              reviewButtonOnClick('forward')
            }}
            variant={'contained'}
            color="primary"
            disabled={selectedData?.length === 0}
          >
            <div className={classes.limitedUseTextAll}>
              <AddToDriveIcon className={classes.useIcon}></AddToDriveIcon>
              {'REPURPOSE'}
            </div>
          </Button>
        )
      }
      case Number(1): {
        return (
          <Button
            data-id={'reviewRepurposeImages'}
            onClick={() => {
              reviewButtonOnClick('forward')
            }}
            variant={'contained'}
            color="primary"
            disabled={
              !selectedData?.some(
                (obj) => obj?.source_image_data?.source_file_name
              ) || selDataDuplicates?.length > 0
            }
          >
            <div className={classes.limitedUseTextAll}>{'Review Details'}</div>
          </Button>
        )
      }
      case Number(2): {
        return (
          <Button
            loading={showRepurposeLoader}
            loadingPosition="start"
            data-id={'completeRepurpose'}
            onClick={completeRepurposeOnclick}
            variant={'contained'}
            color="primary"
            disabled={selectedData?.length === 0}
          >
            <div className={classes.limitedUseTextAll}>
              {'Complete Repurpose'}
            </div>
          </Button>
        )
      }
      default:
        break
    }
  }

  /**
   * Renders the appropriate content for each step in the workflow based on the current active step.
   *
   * @returns {JSX.Element | null} - The JSX content for the current step, or `null` if no step matches.
   *
   * @description
   * - The function determines the content to render based on the `activeStep` value.
   * - Each step has its own specific content:
   *   - **Step 0**: Calls `renderPackagingAssets` to display a list of packaging assets with a "Select All" checkbox and renders asset cards.
   *   - **Step 1**: Calls `renderAssignSourceImagesPage` to render the page for assigning source images.
   *   - **Step 2** and **Step 3**: Calls `renderReviewRepurposePage` to render final list to repurpose.
   */
  const renderStepperPages = () => {
    switch (activeStep) {
      case Number(0): {
        return renderPackagingAssets()
      }
      case Number(1): {
        return renderAssignSourceImagesPage()
      }
      case Number(2):
      case Number(3): {
        return renderReviewRepurposePage()
      }
      default:
        break
    }
  }

  const renderPackagingAssets = () => {
    const packagingAssets = [...(asset_info || [])]
    const normalizedFilter = (assetFilterText || '').trim().toLowerCase()
    const filteredPackagingAssets = !normalizedFilter
      ? packagingAssets
      : packagingAssets.filter((asset = {}) => {
          const {
            file_name: fileName = '',
            source_channel: sourceChannel = '',
          } = asset
          return (
            fileName.toLowerCase().includes(normalizedFilter) ||
            sourceChannel.toLowerCase().includes(normalizedFilter)
          )
        })
    const selectedIds = packagingAssets?.filter(
      (aobj) => extractFileType(aobj.file_name) !== 'ai'
    )
    const isSelectAllAssets = selectedIds?.every((asset) =>
      selectedData?.some((selected) => selected?.asset_id === asset?.asset_id)
    )
    return (
      <>
        <Grid item container xs={12} style={{ padding: '16px 9px 0px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              id="filterPackagingAssets"
              value={assetFilterText}
              onChange={(event) => setAssetFilterText(event.target.value)}
              placeholder="Filter by image name or source channel"
              variant="outlined"
              size="small"
              fullWidth
              inputProps={{ maxLength: 150 }}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} style={{ padding: '22px 9px 0px' }}>
          <FormControlLabel
            control={
              <Checkbox
                id="selectAllImages"
                color="primary"
                onChange={(event) => {
                  onCheckBoxHeaderChange()
                }}
                checked={isSelectAllAssets}
                classes={{
                  checked: classes.filterCheckboxChecked,
                }}
              />
            }
            componentsProps={{
              typography: {
                variant: 'button',
                gutterBottom: true,
                noWrap: true,
              },
            }}
            label={'Select All'}
            className={classes.selectAllControl}
          />
        </Grid>
        <Grid item container xs={12} className={classes.assetListContainer}>
          {renderAssetList(filteredPackagingAssets)}
        </Grid>
      </>
    )
  }

  const formatSourceImage = (sourceImagesList, event = {}) => {
    const { value: currentOptionValue = '' } = event || {}
    const findImageObj = sourceImagesList?.find(
      (obj) => obj?.file_name === currentOptionValue
    )
    const sourceImageObj = findImageObj || { file_name: currentOptionValue }
    return {
      source_file_name: sourceImageObj?.file_name || '',
      source_image_url: sourceImageObj?.source_image?.preview_image_url || '',
    }
  }

  const formattedEvent = (event = {}) => {
    const { value: currentOptionValue = '' } = event || {}
    const curOptValue =
      extractFileType(currentOptionValue) !== '.tif'
        ? `${currentOptionValue + '.tif'}`
        : currentOptionValue
    const newEvent = {
      ...event,
      ...{ value: curOptValue },
    }
    return newEvent
  }

  const sourceDropdownChange = (event = {}, actionMeta, asset = {}) => {
    const newEvent =
      actionMeta?.action === 'create-option' ? formattedEvent(event) : event
    const { value: currentOptionValue = '' } = newEvent || {}
    const { asset_id = '' } = asset
    const newRepurposeList = repurposeList?.map((obj) => {
      return obj?.asset_id === asset_id
        ? Object.assign({}, obj, { source_file_name: currentOptionValue })
        : obj
    })
    const newSourceImagesDDList = sourceImagesDDList?.some(
      (obj) => obj?.value === currentOptionValue
    )
      ? sourceImagesDDList
      : [...sourceImagesDDList, newEvent] //If the current option value is not found, it adds a new event to the dropdown list.
    const formattedSourceImage = formatSourceImage(sourceImagesList, newEvent)

    // Updates the selectedData and adds additional source image data where the given asset_id matches
    const newSelectedData = selectedData?.map((selObj) => {
      return selObj?.asset_id === asset_id
        ? {
            ...selObj,
            source_image_data: formattedSourceImage,
            sourceDDObj: newEvent || {},
          }
        : selObj
    })

    startTransition(() => {
      setSourceImagesDDList(newSourceImagesDDList)
      setSelectedData(newSelectedData)
      setRepurposeList(newRepurposeList)
    })
  }

  const renderAssignSourceImagesTBody = () => {
    const versionTable = []
    const dropdownOptions = sourceImagesDDList || []
    const sortedOptions = Object.values(dropdownOptions).sort((a, b) =>
      sortAlphaNum(a.label, b.label)
    )
    const newselectedData = [...selectedData]
    newselectedData?.map((asset, index) => {
      const {
        render_urls: { preview_asset_url = '' } = {},
        file_name: fileName = '',
        asset_id = '',
        sourceDDObj = {},
        source_image_data: {
          source_file_name = '',
          source_image_url = '',
        } = {},
      } = asset
      const isDuplicate = selDataDuplicates?.some(
        (obj) => obj?.asset_id === asset_id
      )
      const buttonColor = isDuplicate ? 'primary' : ''
      const fileType = extractFileType(fileName)
      const srcUrl = preview_asset_url
        ? appendAHKeyParamToUrl(preview_asset_url)
        : ''
      versionTable.push(
        <TableRow key={asset_id}>
          <TableCell className={classes.padding10}>{fileName || ''}</TableCell>
          <TableCell className={classes.textCenter}>
            {srcUrl ? (
              <img
                height={80}
                src={srcUrl}
                alt="Not Found"
                onError={(e) => {
                  e.target.src = NoThumbnail
                }}
              />
            ) : (
              <ImageNA
                title="Image Not Available"
                className={classes.noImage}
              />
            )}
          </TableCell>
          <TableCell className={classes.padding10 + ' ' + classes.textCenter}>
            {fileType}
          </TableCell>
          <TableCell className={classes.textCenter}>
            {/* {'source image dropdown'} */}
            <CreatableSelect
              index={index}
              distinct={sortedOptions}
              classes={classes}
              dropdownValue={source_file_name}
              selectedValue={sourceDDObj || {}}
              selectedOptionValue={source_file_name}
              handleDropdownChange={(event, actionMeta) => {
                sourceDropdownChange(event, actionMeta, asset)
              }}
              isCreatable={true}
              isReadOnly={false}
              componentLabel={'Select Source'}
              isNewOption={false}
              isDisabled={false}
              isClearable={true}
              buttonColor={buttonColor}
            />
          </TableCell>
          <TableCell className={classes.padding10 + ' ' + classes.textCenter}>
            {source_image_url ? (
              <img height={80} src={source_image_url} alt="Not Found" />
            ) : (
              <ImageNA
                title="Image Not Available"
                className={classes.noImage}
              />
            )}
          </TableCell>
          <TableCell
            align="right"
            className={classes.padding10 + ' ' + classes.textCenter}
          >
            <IconButton
              aria-label="Delete"
              onClick={(event) => {
                onSelection(event, asset)
              }}
              size="large"
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </TableCell>
        </TableRow>
      )
      return true
    })

    return [...versionTable]
  }

  const renderAssignSourceImagesPage = () => {
    return (
      <Grid
        container
        direction={'column'}
        style={{ paddingTop: '30px', height: '660px' }}
        justifyContent={'flex-start'}
      >
        <Grid item>
          <TableContainer component={Paper} style={{ height: 630 }}>
            <Table className={classes.reviewtable} stickyHeader>
              <TableHead>
                <TableRow>
                  {assignSourceImagesTableCols?.map((thList) => {
                    return (
                      <TableCell
                        className={
                          classes.TableHead +
                          ' ' +
                          classes.padding10 +
                          ' ' +
                          classes.textCenter +
                          ' ' +
                          classes.header
                        }
                      >
                        {thList}
                      </TableCell>
                    )
                  })}
                </TableRow>
              </TableHead>
              <TableBody className={classes.versionTable}>
                {renderAssignSourceImagesTBody()}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    )
  }

  //TODO - Need to implement the drag and drop functionality
  const onDragEnd = (result) => {
    const { destination, source } = result

    // If no destination, do nothing
    if (!destination) return

    // Reorder the repurposeList
    const reorderedList = Array.from(repurposeList)
    const [removed] = reorderedList.splice(source.index, 1)
    reorderedList.splice(destination.index, 0, removed)

    // setRepurposeList(reorderedList)
  }

  const simpleImageCard = (fileName = '', srcUrl = '', asset_id = '') => {
    const errorFiles = failedFiles || []
    const cardType =
      errorFiles?.findIndex((obj) => obj?.asset_id === asset_id) !== -1
        ? 'error'
        : (successFiles || [])?.findIndex(
              (obj) => obj?.asset_id === asset_id
            ) !== -1
          ? 'success'
          : 'normal'
    const cardTypeSX =
      cardType === 'error'
        ? { width: 150, border: '2px solid #B85300' }
        : cardType === 'success'
          ? { width: 150, border: '2px solid #4CAF50' }
          : { width: 150 }
    return (
      <Card sx={{ ...cardTypeSX }}>
        <CardActions
          style={{
            borderBottom: '1px solid #f4f0f0',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Tooltip
            title={fileName}
            placement="top-start"
            disableHoverListener={fileName?.length <= 15 ? true : false}
          >
            <div className={classes.fileName}>{fileName || ''}</div>
          </Tooltip>
        </CardActions>
        <CardContent>
          {srcUrl ? (
            <a
              data-cy="assetCardLink"
              alt={fileName}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (srcUrl) {
                  dispatch(openZoomedImage(fileName, srcUrl))
                }
              }}
              className={classes.fileName}
              href={() => false}
            >
              <img
                height={80}
                src={srcUrl}
                alt="Not Found"
                onError={(e) => {
                  e.target.src = NoThumbnail
                }}
              />
            </a>
          ) : (
            <ImageNA title="Image Not Available" className={classes.noImage} />
          )}
        </CardContent>
      </Card>
    )
  }

  const simpleAlertCard = (alertType = '', alertTitle = '', alertMsg = '') => {
    return (
      <Alert
        severity={alertType}
        style={{ border: '2px solid rgb(30, 70, 32)' }}
      >
        <AlertTitle>{<strong>{`${alertTitle}`}</strong>}</AlertTitle>
        {alertMsg}
      </Alert>
    )
  }

  const generateAlertMessage = () => {
    let alertTitle = ''
    let alertMsg = ''
    let alertType = ''
    switch (repurposeStatus) {
      case 'success':
        alertType = 'success'
        alertTitle = `${'Repurposed Successfully'}`
        alertMsg = `${'Source images will be processed and added to the workflow with the major version of the file updated.'}`
        break
      case 'partial':
        alertType = 'warning'
        alertTitle = `${'Repurposed Partially'}`
        alertMsg = (
          <span>
            Encountered an error while trying to repurpose the images.
            <br /> Retry (or) Contact Photobridge team on slack.
            <br />
            Remaining images will be processed and added to the workflow.
          </span>
        )
        break
      case 'failed':
        alertType = 'error'
        alertTitle = `${'Failed to Repurpose'}`
        alertMsg = (
          <span>
            Encountered an error while trying to repurpose the images.
            <br /> Retry (or) Contact Photobridge team on slack.
          </span>
        )
        break
      default:
        break
    }
    return simpleAlertCard(alertType, alertTitle, alertMsg)
  }

  const renderReviewRepurposePage = () => {
    return (
      <>
        <Grid
          item
          container
          xs={12}
          style={{ padding: '22px 9px 0px', justifyContent: 'center' }}
        >
          {!isEmpty(repurposeStatus) && generateAlertMessage()}
        </Grid>
        {isEmpty(repurposeStatus) && finalSelectedData?.length > 0 && (
          <Grid
            container
            spacing={2}
            style={{ height: '650px', overflowY: 'scroll' }}
            justifyContent={'center'}
          >
            {/* File Name Column */}
            <Grid item xs={2}>
              <h4 style={{ textAlign: 'center' }}>Packaging Image(s)</h4>
              <Grid container direction="column" spacing={1}>
                {finalSelectedData?.map((data = {}, index) => {
                  const {
                    file_name = '',
                    render_urls: { preview_asset_url = '' } = {},
                    asset_id = '',
                  } = data || {}
                  const srcUrl = preview_asset_url
                    ? appendAHKeyParamToUrl(preview_asset_url)
                    : ''
                  return (
                    <Grid
                      item
                      key={index}
                      className={classes.finalImagesContainer}
                    >
                      {simpleImageCard(file_name, srcUrl, asset_id)}
                    </Grid>
                  )
                })}
              </Grid>
            </Grid>
            <Grid item>
              <h4 style={{ textAlign: 'center' }}>
                <DoubleArrowIcon />
              </h4>
              {finalSelectedData?.map((data = {}, index) => {
                const {
                  file_name = '',
                  render_urls: { preview_asset_url = '' } = {},
                  asset_id = '',
                } = data || {}
                const srcUrl = preview_asset_url
                  ? appendAHKeyParamToUrl(preview_asset_url)
                  : ''
                return (
                  <Grid
                    item
                    container
                    key={index}
                    className={classes.arrowContainer}
                  >
                    <KeyboardDoubleArrowRightIcon />
                  </Grid>
                )
              })}
            </Grid>
            {/* Source File Name (Draggable) Column */}
            <Grid item xs={2}>
              <h4 style={{ textAlign: 'center' }}>Source Image(s)</h4>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="sourceFileNameColumn">
                  {(provided) => (
                    <Grid
                      container
                      direction="column"
                      spacing={1}
                      justifyContent={'center'}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {finalSelectedData?.map((item = {}, index) => {
                        const {
                          asset_id = '',
                          source_image_data: {
                            source_file_name = '',
                            source_image_url = '',
                          } = {},
                        } = item || {}
                        return (
                          <Draggable
                            key={asset_id}
                            draggableId={asset_id?.toString()}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <Grid
                                item
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  padding: '8px',
                                  margin: '4px 0',
                                  backgroundColor: snapshot.isDragging
                                    ? 'lightblue'
                                    : 'white',
                                  borderRadius: '4px',
                                  textAlign: 'center',
                                  alignSelf: 'center',
                                }}
                              >
                                {simpleImageCard(
                                  source_file_name,
                                  source_image_url,
                                  asset_id
                                )}
                              </Grid>
                            )}
                          </Draggable>
                        )
                      })}
                      {provided.placeholder}
                    </Grid>
                  )}
                </Droppable>
              </DragDropContext>
            </Grid>
          </Grid>
        )}
      </>
    )
  }

  const onRepurposeMore = () => {
    startTransition(() => {
      setActiveStep(Number(0))
      setRepurposeList([])
      setSelectedData([])
      setFinalSelectedData([])
      setSelDataDuplicates([])
      setFailedFiles([])
      setSuccessFiles([])
      setSourceImagesDDList(defaultSourceImagesDDList || [])
      setRepurposeStatus('')
    })
  }

  const renderAssets = () => {
    return (
      <Grid
        container
        style={{
          maxHeight: 'calc(120vh)',
          overflowY: 'hidden',
        }}
      >
        <Grid
          container
          justifyContent={'space-between'}
          spacing={2}
          alignItems={'baseline'}
          style={{ padding: '20px 8px 2px 8px' }}
        >
          <Grid item>
            {stepperLabels?.at(activeStep) && (
              <>
                <h3 style={{ margin: '2px 0px' }}>
                  {stepperLabels?.at(activeStep)}
                </h3>
                {stepperCaptions?.at(activeStep) && (
                  <Typography variant="caption" style={{ fontStyle: 'italic' }}>
                    {`${'(' + stepperCaptions?.at(activeStep) + ')'}`}
                  </Typography>
                )}
              </>
            )}
          </Grid>
          <Grid item xs={4}>
            <Grid
              container
              justifyContent={'flex-end'}
              alignItems={'baseline'}
              spacing={1}
            >
              {activeStep !== Number(0) && (
                <Grid item>
                  {activeStep < Number(3) ? (
                    <Button
                      color="primary"
                      id="backward"
                      onClick={() => {
                        reviewButtonOnClick('backward')
                      }}
                      variant="outlined"
                      className={classes.defaultButton}
                    >
                      BACK
                    </Button>
                  ) : (
                    <Button
                      color="primary"
                      id="repurposeMore"
                      data-cy="repurposeMore"
                      onClick={() => {
                        onRepurposeMore()
                      }}
                      variant="text"
                      className={classes.defaultButton}
                      startIcon={<ReplayIcon />}
                    >
                      {'Repurpose More'}
                    </Button>
                  )}
                </Grid>
              )}
              <Grid item>{renderPageControls()}</Grid>
            </Grid>
          </Grid>
        </Grid>

        {renderStepperPages()}
      </Grid>
    )
  }

  return (
    <Grid
      container
      direction={'column'}
      style={{ padding: '10px' }}
      justifyContent={'flex-start'}
    >
      {asset_info?.length ? (
        <Grid item>{renderAssets()}</Grid>
      ) : (
        <Grid item>{renderNoRecords()}</Grid>
      )}
    </Grid>
  )
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  limitedUseText: {
    color: 'rgba(223, 139, 72, 1)',
    display: 'flex',
    alignItems: 'center',
    fontSize: 11,
  },
  disabledButton: {
    display: 'flex',
    alignItems: 'center',
  },
  limitedUseTextDone: {
    color: green[500],
    display: 'flex',
    alignItems: 'center',
  },
  limitedUseTextAll: {
    display: 'flex',
    alignItems: 'center',
  },
  asset: {
    height: '150px !important',
    width: 'auto !important',
  },
  fileName: {
    paddingBottom: '4px',
    paddingTop: '4px',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    hyphens: 'auto',
    fontSize: 12,
    color: '#0D46A0',
    lineHeight: '16px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '105px',
    display: 'block',
  },
  card: {
    width: '150px',
    height: 'auto',
    borderRadius: '8px',
    position: 'relative',
    boxShadow: '#ececec 0px 0px 5px',
    border: '1px solid #f4f0f0',
    marginRight: 10,
  },
  errorCard: {
    width: '285px',
    height: 'auto',
    borderRadius: '8px',
    position: 'relative',
    boxShadow: '#ececec 0px 0px 5px',
    border: '2px solid #B85300',
    marginRight: 10,
  },
  successCard: {
    width: '285px',
    height: 'auto',
    borderRadius: '8px',
    position: 'relative',
    boxShadow: '#ececec 0px 0px 5px',
    border: '2px solid green',
    marginRight: 10,
  },
  TableHead: {
    fontSize: '15px !important',
    fontWeight: '700 !important',
  },
  padding10: {
    paddingRight: 10,
    paddingLeft: 10,
  },
  textCenter: {
    textAlign: 'center !important',
  },
  reviewtable: {
    minWidth: 400,
    position: 'relative',
    backgroundColor: '#dddddd',
  },
  versionTable: {
    backgroundColor: '#F9F9F9',
  },
  checkBoxCls: {
    padding: '2px !important',
  },
  header: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#F7F7F7',
  },
  arrowContainer: {
    padding: '8px',
    margin: '4px 0',
    backgroundColor: 'white',
    borderRadius: '4px',
    textAlign: 'center',
    alignSelf: 'center',
    height: '175px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  finalImagesContainer: {
    padding: '8px',
    margin: '4px 0',
    backgroundColor: 'white',
    borderRadius: '4px',
    textAlign: 'center',
    alignSelf: 'center',
  },
  imgBlockCls: {
    width: '100%',
    display: 'block',
  },
  dropdownButton: {
    textTransform: 'none!important',
    fontSize: '15px',
    color: 'rgba(0, 0, 0, 0.6) !important',
    paddingRight: '0px !important',
    paddingLeft: '0px !important',
    minWidth: '40px !important',
    height: '30px !important',
  },
  uploadDate: {
    fontSize: '10px',
  },
  assetListContainer: {
    maxHeight: '600px',
    overflowY: 'scroll',
    gap: '20px',
    paddingBottom: '5px',
  },
  drmId: {
    fontSize: '12px',
    paddingBottom: '5px',
  },
  usageInfo: {
    padding: '10px',
  },
  usageText: {
    fontSize: '10px',
    paddingBottom: '3px',
  },
  drmButton: {
    width: '100px',
    height: '22px',
    fontSize: '12px',
    backgroundColor: '#188295',
    color: 'white',
    border: 'none',
  },
  limitedUseButton: {
    width: 'auto',
    height: '22px',
    fontSize: '12px',
    backgroundColor: '#FAFAFA',
    border: 'none',
    cursor: 'auto',
    borderRadius: 5,
    '&:hover': {
      backgroundColor: '#F4F4F4',
    },
  },
  noUseButton: {
    width: 'auto',
    height: '22px',
    fontSize: '12px',
    backgroundColor: '#FAFAFA',
    border: 'none',
    cursor: 'auto',
    borderRadius: 5,
    '&:hover': {
      backgroundColor: '#F4F4F4',
    },
  },
  noUseText: {
    color: 'rgba(204, 0, 0, 1)',
    display: 'flex',
    alignItems: 'center',
    fontSize: 11,
  },
  usageHeader: {
    padding: '10px',
    display: 'flex',
  },
  useCardIcon: {
    height: '15px !important',
    width: '15px !important',
    paddingRight: '5px',
  },
  useIcon: {
    width: '12px !important',
    height: '12px !important',
    paddingRight: '3px',
    paddingLeft: '1px',
  },
})

const mapAuthToProps = (auth) => {
  return {
    accessToken: auth.session?.userInfo?.accessToken,
    company: auth.session?.userInfo?.company,
    memberOf: auth.session?.userInfo?.memberOf,
    lanId: auth.session?.userInfo?.lanId,
  }
}

export default withAuth(mapAuthToProps)(React.memo(PackagingAssetsList))
